import { getPrimaryColor, JEJURO } from '@orcar/common-d2c';
import { Dayjs } from 'dayjs';
import { Dispatch, SetStateAction, useState } from 'react';
import styled from 'styled-components';
import HeroDateModal from './HeroDateModal';

type HeroSearchBarProps = {
  pickUpDate: Dayjs;
  setPickUpDate: Dispatch<SetStateAction<Dayjs>>;
  dropOffDate: Dayjs;
  setDropOffDate: Dispatch<SetStateAction<Dayjs>>;
  pickUpTimeValue: number;
  dropOffTimeValue: number;
  setPickUpTimeValue: Dispatch<SetStateAction<number>>;
  setDropOffTimeValue: Dispatch<SetStateAction<number>>;
  /** 날짜+시간이 합쳐진 표시용 값 */
  pickUpAt: Dayjs;
  dropOffAt: Dayjs;
  onSearch: () => void;
};

const HeroSearchBar = ({
  pickUpDate,
  setPickUpDate,
  dropOffDate,
  setDropOffDate,
  pickUpTimeValue,
  dropOffTimeValue,
  setPickUpTimeValue,
  setDropOffTimeValue,
  pickUpAt,
  dropOffAt,
  onSearch,
}: HeroSearchBarProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Bar>
      <Field type='button' onClick={() => setIsModalOpen(true)}>
        <FieldLabel>대여일시</FieldLabel>
        <FieldValue>
          {pickUpAt.format('MM.DD')}
          <Day>({pickUpAt.format('dd')})</Day>
          <Sep aria-hidden>|</Sep>
          {pickUpAt.format('HH:mm')}
        </FieldValue>
      </Field>

      <Divider />

      <Field type='button' onClick={() => setIsModalOpen(true)}>
        <FieldLabel>반납일시</FieldLabel>
        <FieldValue>
          {dropOffAt.format('MM.DD')}
          <Day>({dropOffAt.format('dd')})</Day>
          <Sep aria-hidden>|</Sep>
          {dropOffAt.format('HH:mm')}
        </FieldValue>
      </Field>

      <SearchButton type='button' onClick={onSearch}>
        차량 검색
      </SearchButton>

      {isModalOpen && (
        <HeroDateModal
          pickUpDate={pickUpDate}
          setPickUpDate={setPickUpDate}
          dropOffDate={dropOffDate}
          setDropOffDate={setDropOffDate}
          pickUpTimeValue={pickUpTimeValue}
          dropOffTimeValue={dropOffTimeValue}
          setPickUpTimeValue={setPickUpTimeValue}
          setDropOffTimeValue={setDropOffTimeValue}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </Bar>
  );
};

export default HeroSearchBar;

const Bar = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  gap: 6px;
  padding: 14px;
  border-radius: 18px;
  background: ${({ theme }) => theme.COLOR.WHITE};
  box-shadow: 0 20px 50px rgba(6, 20, 32, 0.22);
`;

const Field = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background: none;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.COLOR.GREY_BG};
  }
`;

const FieldLabel = styled.span`
  ${({ theme }) => theme.FONT.B3};
  font-weight: 700;
  color: ${({ theme }) => theme.COLOR.GREY_02};
`;

const FieldValue = styled.span`
  display: flex;
  align-items: center;
  gap: 7px;
  ${({ theme }) => theme.FONT.H4};
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.COLOR.GREY_01};
`;

const Day = styled.span`
  ${({ theme }) => theme.FONT.B2};
  font-weight: 600;
  color: ${({ theme }) => theme.COLOR.GREY_02};
`;

const Sep = styled.span`
  color: ${({ theme }) => theme.COLOR.GREY_04};
  font-weight: 400;
`;

const Divider = styled.div`
  width: 1px;
  margin: 12px 0;
  background: ${({ theme }) => theme.COLOR.GREY_04};
`;

const SearchButton = styled.button`
  flex: none;
  padding: 0 40px;
  border: none;
  border-radius: 12px;
  ${({ theme }) => theme.FONT.H4};
  font-weight: 700;
  color: ${({ theme }) => theme.COLOR.WHITE};
  background: ${getPrimaryColor(JEJURO)};
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.92;
  }
`;
